import { FC } from "react";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { useWidth } from "@/shared/hooks/use-width.hook";
import dayjs from "dayjs";

const DataLog = () => {
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const { userIs } = useUserHasPermission();
  const {
    PROPERTY_DETAIL: { principalData, dataLog }
  } = useRealEstateDetailContext();

  const isPropertyStatus = (status: number[]) =>
    status.includes(principalData.property_status.id);

  const showIs = {
    dateExpiration: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    dateCreation: true,
    creatorProperty: true,
    lastModificationDate: true,
    lastUserModificationProperty: true,
    dateDropProperty: isPropertyStatus([
      // C_PROPERTIES_STATUS.ACTIVE.id,
      // C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id
      // C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      // C_PROPERTIES_STATUS.PRECAPTURED.id,
    ]),
    userDropProperty: isPropertyStatus([
      // C_PROPERTIES_STATUS.ACTIVE.id,
      // C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id
      // C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      // C_PROPERTIES_STATUS.PRECAPTURED.id,
    ]),
    datePublicationProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    userPublicationProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    dateResolveConflictProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      // C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    userResolveConflictProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      // C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    dateReactivationProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),

    dateOutNegotiationProperty: isPropertyStatus([
      // C_PROPERTIES_STATUS.ACTIVE.id,
      C_PROPERTIES_STATUS.INNEGOTIATION.id
      // C_PROPERTIES_STATUS.DROPPED.id,
      // C_PROPERTIES_STATUS.INCONFLICT.id,
      // C_PROPERTIES_STATUS.PENDING.id,
      // C_PROPERTIES_STATUS.PRECAPTURED.id,
    ]),
    daysOutNegotiationProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      // C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ]),
    dateApprovedProperty: isPropertyStatus([
      C_PROPERTIES_STATUS.ACTIVE.id,
      // C_PROPERTIES_STATUS.INNEGOTIATION.id,
      C_PROPERTIES_STATUS.DROPPED.id,
      C_PROPERTIES_STATUS.INCONFLICT.id,
      C_PROPERTIES_STATUS.PENDING.id,
      C_PROPERTIES_STATUS.PRECAPTURED.id
    ])
  };

  const properties = [
    {
      label: "Fecha de expiración de la propiedad",
      value: dataLog?.expires_property ?? null,
      show: showIs.dateExpiration
    },
    {
      label: "Fecha de creación de la propiedad",
      value: dataLog?.created_property ?? null,
      show: showIs.dateCreation
    },
    {
      label: "Creador propiedad",
      value: dataLog?.property_creator ?? null,
      show: showIs.creatorProperty
    },
    {
      label: "Fecha de última modificación de propiedad",
      value: dataLog?.last_modified_date ?? null,
      show: showIs.lastModificationDate
    },
    {
      label: "Último usuario que modificó la propiedad",
      value: dataLog?.last_user_modified_property ?? null,
      show: showIs.lastUserModificationProperty
    },
    {
      label: "Fecha de dada de baja de propiedad",
      value: dataLog?.property_dropped_date ?? null,
      show: showIs.dateDropProperty
    },
    {
      label: "Usuario que dio de baja a la propiedad",
      value: dataLog?.last_user_dropped_property ?? null,
      show: showIs.userDropProperty
    },
    {
      label: "Fecha de publicación de propiedad",
      value: dataLog?.property_publication_date ?? null,
      show: showIs.datePublicationProperty
    },
    {
      label: "Usuario que publico la propiedad",
      value: dataLog?.property_user_published ?? null,
      show: showIs.userPublicationProperty
    },

    {
      label: "Fecha en la que se resolvió conflicto",
      value: dataLog?.property_resolve_conflict_date ?? null,
      show: showIs.dateResolveConflictProperty
    },
    {
      label: "Usuario que resolvió conflicto",
      value: dataLog?.conflict_resolver ?? null,
      show: showIs.userResolveConflictProperty
    },

    {
      label: "Fecha de reactivación la propiedad",
      value: dataLog?.property_reactivation_date ?? null,
      show: showIs.dateReactivationProperty
    },
    {
      label: "Fecha en la que la propiedad saldrá de negociación",
      value: dataLog?.property_out_negotiation_date ?? null,
      show: showIs.dateOutNegotiationProperty
    },
    {
      label: "Días que la propiedad estará en negociación",
      value: dataLog?.property_out_negotiation_days ?? null,
      show: showIs.daysOutNegotiationProperty
    },
    {
      label: "Fecha en la que se aprobó la propiedad",
      value: dataLog?.activated ?? null,
      show: showIs.dateApprovedProperty
    }
  ].filter(item => item.show && item.value);

  return (
    <Container id="data-log-container">
      <TextSimple color="blue" size="title" font="gotham" weight="700">
        Log de datos
      </TextSimple>

      <Content isMobile={isMobile}>
        {properties.map((item, index) => {
          return (
            <TextModified key={index} title={item.label} description={item.value} />
          );
        })}
      </Content>
    </Container>
  );
};

export default DataLog;

const Container = styled.div`
  margin-top: 20px;
  width: 100%;
  border: 0px solid #ccc;
  border-radius: 15px;
  background: #fff;
  padding: 25px 40px;
`;

const Content = styled.div<{ isMobile: boolean }>`
  margin-top: 10px;
  display: ${props => (props.isMobile ? "flex" : "grid")};
  flex-wrap: wrap;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 25px;
  row-gap: 14px;
`;

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

interface ITextModified {
  title: string;
  description: string | null;
}

const TextModified: FC<ITextModified> = props => {
  return (
    <TextContainer>
      <TextSimple color="gray" size="label" font="inter" weight="300">
        {props?.title}
      </TextSimple>
      <TextSimple color="gray" size="label" font="gotham" weight="700">
        {props?.description}
      </TextSimple>
    </TextContainer>
  );
};
